import React from "react";
import { Modal, Typography } from "@thingsw/pitta-design-system";
import { Theme, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../features/store";
import { THEME } from "../../features/Theme/slice";

const useStyles = makeStyles((theme: Theme) => ({
  disConnectModal: {
    width: "350px",
  },
  disConnectModalButton: {
    width: "100%",
  },

  titleDiv: {
    marginBottom: 24,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  textDiv: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
}));

interface BatteryConnectionLostModalProps {
  open: boolean;
  onClickPositive: () => void;
}

const BatteryConnectionLostModal = (props: BatteryConnectionLostModalProps) => {
  const { t } = useTranslation();
  const { colors } = useSelector((root: RootState) => root[THEME]);

  const { open, onClickPositive } = props;

  const classes = useStyles(props);

  return (
    <Modal
      mobile
      open={open}
      className={classes.disConnectModal}
      fullWidthBtn
      RButtonClassName={classes.disConnectModalButton}
      RButton={t("Back to list")}
      onClickPositive={onClickPositive}
      content={
        <div>
          <div className={classes.textDiv}>
            <Typography variant="H6" htmlColor={colors.primary["1"]}>
              {t("Connection lost")}
            </Typography>
            <Typography variant="Body" htmlColor={colors.primary["1"]}>
              {t("A connection error has occurred shortly")}
            </Typography>
          </div>
        </div>
      }
    />
  );
};

export default BatteryConnectionLostModal;
